<template>
  <div class="news_detail">
    <div class="news_detail_title">{{ name }}
    </div>
    <div class="news_detail_time">
        {{happenTimeFun(time)}}
    </div>
    <div class="news_detail_content">
      <div class="news_detail_content_ul">
        <p v-for="(item, index) in dataArr" :key="index">
          {{ item.text }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      dataArr: [],
      id: "",
      name: "",
      time: "",
    };
  },
  created() {
    this.id = this.$route.query.did;
    this.name = this.$route.query.title;
    this.time = this.$route.query.time;
    this.init();
  },
  methods: {
    init() {
      $.ajax({
        url:"/static/json/news/" + this.id + ".json",
        type:'GET',
        success:(res)=>{
        this.dataArr = res;
        }
      })
    },
    happenTimeFun(num) {
      //时间戳数据处理

      let date = new Date(num * 1000);

      //时间戳为10位需*1000，时间戳为13位的话不需乘1000

      let y = date.getFullYear();

      let MM = date.getMonth() + 1;

      MM = MM < 10 ? "0" + MM : MM; //月补0

      let d = date.getDate();

      d = d < 10 ? "0" + d : d; //天补0

      let h = date.getHours();

      h = h < 10 ? "0" + h : h; //小时补0

      let m = date.getMinutes();

      m = m < 10 ? "0" + m : m; //分钟补0

      let s = date.getSeconds();

      s = s < 10 ? "0" + s : s; //秒补0

      return y + "-" + MM + "-" + d ;
    }
  },
};
</script>
<style lang="scss" scoped>
.news_detail {
  // background-color: rgb(247, 243, 237);
  .news_detail_title {
    margin: 0 auto;
    width: 1200px;
    font-family: bold;
    font-size: 24px;
    text-align: center;
    line-height: 52px;
    padding-top: 50px;
    margin-bottom: 18px;
  }
  .news_detail_time{
    margin: 0 auto;
    width: 1200px;
    color: #666;
    text-align: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
  }
  .news_detail_content {
    width: 1200px;
    margin: 0 auto;
    padding: 0px 20px 100px;
    display: flex;
    .news_detail_content_ul {
      width: 100%;
      padding: 30px 0px;
      p {
        width: 100%;
        padding: 0px 40px;
        box-sizing: border-box;
        line-height: 30px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>